import { render, staticRenderFns } from "./OrderFieldEditor.vue?vue&type=template&id=0b1d42be&scoped=true"
import script from "./OrderFieldEditor.vue?vue&type=script&lang=js"
export * from "./OrderFieldEditor.vue?vue&type=script&lang=js"
import style0 from "./OrderFieldEditor.vue?vue&type=style&index=0&id=0b1d42be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1d42be",
  null
  
)

export default component.exports